// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3o6oX","rootNoMargin":"styles_rootNoMargin__2eGAM"};